import { create } from "zustand";
import { UserStoreTypes } from "./storeTypes/userStoreTypes";
import { ExamThumbnailTypes } from "../interfaces/exam.interface";
import { EUserType } from "../environment";

const useUserDataStore = create<UserStoreTypes>((set) => ({
    thumbnailDetailsList:[],
    currUserType:null,
    isMonitorAdminGroup:false,
    currentOrgainzation:undefined,
    setCurrentOrganization:(data:any)=>set(()=>({currentOrgainzation:data})),
    setToken:(data:string|undefined)=>set(()=>({token:data})),
    token:"",
    userdetails:undefined,
    setUserDetails:(data:any)=>set(()=>({userdetails:data})),
    setIsMonitorAdminGroup:(data:boolean)=>set(()=>({isMonitorAdminGroup:data})),
    isQuestionSynced:false,
    setQuestionSynced:(data:boolean)=>set(()=>({isQuestionSynced:data})),
    setOpenExamDialog:(data:boolean)=>set(()=>({openExamDialog:data})),
    islogin:false,
    setislogin:(data:boolean)=>set(()=>({islogin:data})),
    isAdmin:false,
    setisAdmin:(data:boolean)=>set(()=>({isAdmin:data})),
    isTCAdmin:false,
    setisTCAdmin:(data:boolean)=>set(()=>({isTCAdmin:data})),
    isSuperAdminGroup:false,
    setIsSuperAdminGroup:(data:boolean)=>set(()=>({isSuperAdminGroup:data})),
    openExamDialog:false,
    setCurrUserType:(data:EUserType | null)=>set(()=>({currUserType:data})),
    setThumbnailDetails:(data:Array<ExamThumbnailTypes>)=>set(()=>({thumbnailDetailsList:data})),
}));

export default useUserDataStore;